import { hasTracking } from "@escapio/shared/state/client-settings";

customElements.define(
	"esc-matomo-loader",
	class extends HTMLElement {
		connectedCallback() {
			if (!hasTracking) return;
			const _paq = window._paq || [];
			_paq.push(["trackPageView"]);
			_paq.push(["enableLinkTracking"]);
		}
	},
);
